<span mat-button mat-dialog-close class="right pointer">
    <i id="closeOverlay" class="far fa-times-circle"></i>
</span>
<h1 mat-dialog-title>STIPENDI</h1>

<div mat-dialog-content>
    <div class="invoice-box" #htmlPdf>
        <table cellpadding="0" cellspacing="0">
            <tr class="top_rw">
              <td colspan="2">
                <h2 style="margin: 0px">Stipendi</h2>
              </td>
              <td style="width: 30%; margin-right: 10px">
                <p style="margin: 13px">Date: {{ currentDate | date: 'medium' }}</p>
              </td>
            </tr>
            <tr class="information">
              <td colspan="3">
                <table>
                  <tr>
                    <td colspan="2">
                      <b> From: {{ user?.name }} {{ user?.surname }}</b> <br />
                      {{ user?.email }}<br />
                      Website: <a href="https://deluxy.it" target="_blank">Deluxy</a>
                    </td>
                    <td>
                      <b> To: {{ expert?.user?.surname }} {{ expert?.user?.name }} </b><br />
                      {{ expert?.address }}<br />
                      {{ expert?.phone }}<br />
                      {{ expert?.user?.email }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <table cellspacing="0px" cellpadding="2px">
                  <tr class="heading">
                    <td style="width: 10%">DELIVERY ID</td>
                    <td style="width: 25%">DELIVERY INFO</td>
                    <td style="width: 10%">DA FATTURARE</td>
                    <td style="width: 10%; text-align: center">DATE</td>
                    <td style="width: 15%; text-align: center">PRODOTTO</td>
                    <td style="width: 15%; text-align: center">NOME SERVIZIO</td>
                    <td style="width: 10%; text-align: center">TIPO SERVIZIO</td>
                    <td style="width: 10%; text-align: center">NOTE</td>
                    <td style="width: 10%; text-align: center">ORA RITIRO</td>
                    <td style="width: 10%; text-align: center">PLUS / MINUS PREZZO</td>
                    <td style="width: 10%; text-align: center">VALET SALARY</td>
                    <td style="width: 10%; text-align: center">INCASSI CONTANTI</td>
                    <td style="width: 10%; text-align: center">VALET SALARY + PLUS MINUS PREZZO</td>
                    <td style="width: 10%; text-align: center">TOTALE</td>
                  </tr>
                  <tr class="item" *ngFor="let delivery of deliveries; let i = index;">
                    <td style="width: 10%">#{{ delivery?.id }}</td>
                    <td style="width: 25%">{{ delivery?.address }}</td>
                    <td style="width: 10%">{{ delivery?.billable ? "YES" : "NO" }}</td>
                    <td style="width: 10%; text-align: center">{{ delivery.deliveryDate | date:'dd/MM/yyyy' }}</td>
                    <td style="width: 15%; text-align: center">
                      <ng-container *ngIf="delivery?.deliveryProducts && delivery.deliveryProducts.length > 0">
                        <span *ngFor="let product of delivery.deliveryProducts; let last = last">
                          {{ product?.product?.name }}{{ !last ? ', ' : '' }}
                        </span>
                      </ng-container>
                    </td>
                    <td style="width: 15%; text-align: center">{{ showServiceDetails(delivery?.expertServiceId)?.service?.serviceName?.toUpperCase() || "---" }}</td>
                    <td style="width: 10%; text-align: center">
                        {{
                            (showServiceDetails(delivery?.expertServiceId)?.service?.serviceType?.toLowerCase() === "fixedpricesalary" ? "Servizi a Prezzo Fisso" :
                            (showServiceDetails(delivery?.expertServiceId)?.service?.serviceType?.toLowerCase() === "hourlyratesalary" ? "Servizi a Ora" : ""))
                        }} 
                    </td>
                    <td style="width: 10%; text-align: center">{{ delivery?.notes  || "---" }}</td>
                    <td style="width: 10%; text-align: center">
                      {{
                        showServiceDetails(delivery?.expertServiceId)?.service?.serviceType?.toLowerCase() === 'hourlyratesalary'
                          ? (delivery?.startTime && delivery?.endTime
                              ? (delivery.startTime.slice(0, 5) + '-' + delivery.endTime.slice(0, 5))
                              : '---')
                          : (delivery?.pickUpTime || '---')
                      }}
                    </td>
                    <td style="width: 10%; text-align: center">
                      <!-- {{ 
                        delivery?.payable
                          ? (delivery?.valetAdditionalPrice || "0" ) + "€"
                          : ("0 €")
                      }} -->
                      {{ commanForValues(delivery).valetPlusMinusSalary | currency:'EUR' }}
                    </td>
                    <td style="width: 10%; text-align: center">
                      <!-- {{ 
                        delivery?.payable
                          ? (delivery?.expertSalary || "0") + "€"
                          : ("0 €")
                      }} -->
                      {{ commanForValues(delivery).valetSalary | currency:'EUR' }}
                    </td>
                    <td style="width: 10%; text-align: center">
                      <!-- {{ 
                        delivery?.payable
                          ? ((delivery?.payAtDeliveryAmount || 0) | currency:'EUR')
                          : (0 | currency:'EUR')
                      }} -->
                      {{ commanForValues(delivery).payAtDeliveryAmount | currency:'EUR' }}
                    </td>
                    <td style="width: 10%; text-align: center">
                      <!-- {{ 
                        delivery?.payable
                          ? (delivery?.expertSalary ? (delivery?.expertSalary + delivery?.valetAdditionalPrice - delivery?.payAtDeliveryAmount) : 0).toFixed(2) + "€"
                          : ("0 €")
                      }} -->
                      {{ (commanForValues(delivery).valetSalary + commanForValues(delivery).valetPlusMinusSalary) | currency:'EUR' }}
                    </td>
                    <td style="width: 10%; text-align: center">
                      <!-- {{ 
                        delivery?.payable
                          ? (delivery?.expertSalary ? (delivery?.expertSalary + delivery?.valetAdditionalPrice - delivery?.payAtDeliveryAmount) : 0).toFixed(2) + "€"
                          : (0 | currency:'EUR')
                      }} -->
                      {{ commanForValues(delivery).totale | currency:'EUR' }}
                    </td>
                  </tr>
                  <tr class="item sub-total">
                    <td style="width: 15%; text-align: center" colspan="8"></td>
                    <td style="width: 15%; text-align: center">Grand Total</td>
                    <!-- <td style="width: 10%; text-align: center">{{ bottomTotals.refundPlus | currency:'EUR' }}</td> -->
                    <!-- <td style="width: 10%; text-align: center">{{ bottomTotals.prezzo | currency:'EUR' }}</td> -->
                    <td style="width: 10%; text-align: center">{{ bottomTotals.plusMinusPrezzo | currency:'EUR' }}</td>
                    <td style="width: 10%; text-align: center">{{ bottomTotals.valetSalary | currency:'EUR' }}</td>
                    <td style="width: 10%; text-align: center">{{ bottomTotals.payAtDeliveryAmount | currency:'EUR' }}</td>
                    <td style="width: 10%; text-align: center">{{ bottomTotals.valetPlusMinusSalary | currency:'EUR' }}</td>
                    <td style="width: 10%; text-align: center">{{ bottomTotals.grandTotal | currency:'EUR' }}</td>
                  </tr>
                  <tr *ngIf="!deliveries.length">
                    <td style="width: 25%; text-align: center" colspan="12">No Deliveries...</td>
                  </tr>
                </table>
              </td>
            </tr>
            <!-- <tr class="total">
              <td colspan="9" align="right">TOTAL TO PAY : SUM OF SERVIZIO PREZZO (FIXED/HOURLY + PLUS PREZZO) + VAT (22% of fee) : <b> 00 </b></td>
            </tr>
            <tr class="total">
            </tr>
            <tr class="total">
              <td colspan="3" align="right">TOTAL TO RECEIVE: PRODOTTO VALUE - (Fee% + Fee% * Vat[22%])  : <b> 00 </b></td>
            </tr> -->
        </table>
    </div>
</div>

<div mat-dialog-actions>
    <div>
      <button mat-button class="btn" [disabled]="!deliveries.length || disableBtn" (click)="downloadSalary()">
        Download Stipendi<i class="ml-10 far fa-save"></i>
      </button>
      &nbsp;
      <button mat-button class="btn" [disabled]="!deliveries.length || disableBtn" (click)="exportSalaryInfo()">
        Esporta<i class="ml-10 fas fa-file-excel"></i>
      </button>
      &nbsp;
      <button mat-button class="btn" [disabled]="!deliveries.length || disableBtn" (click)="viewSalary()">
        View Stipendi<i class="ml-10 far fa-save"></i>
      </button>
      &nbsp;
      <button mat-button class="btn" [disabled]="!deliveries.length || disableBtn" (click)="sendSalary()" *ngIf="groups.includes('admin') && historyPage === 'active'">
        Invia Stipendi<i class="ml-10 far fa-save"></i>
      </button>
    </div>
  </div>
